import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {ConfigNameValue as _ConfigNameValue} from 'app-ui-componentlibrary/dist/componentLibrary/layout/ConfigNameValue';
import contentMap from 'componentLibrary';

export const ConfigNameValue = (props) => (
  <_ConfigNameValue {...props} {...{contentMap}} />
);
export const DynamicNameValue = connectWithCore(ConfigNameValue);
export default DynamicNameValue;
